var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 28.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.05,
    y: 24.8,
    width: 11.87,
    height: 1.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.05,
    y: 22.19,
    width: 11.87,
    height: 1.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.05,
    y: 19.59,
    width: 11.87,
    height: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.78,10.44h-5V6.7a.57.57,0,0,0,0-.18.76.76,0,0,0-.08-.11l0,0L32,1.73h0a.28.28,0,0,0-.12-.08.39.39,0,0,0-.18,0H17.54a.45.45,0,0,0-.46.45v8.39H12.2A1.14,1.14,0,0,0,11,11.5V22.25a1.15,1.15,0,0,0,1.21,1.06h4.91V30a.44.44,0,0,0,.44.43H36.4a.44.44,0,0,0,.44-.43V23.31h4.94A1.15,1.15,0,0,0,43,22.25V11.5A1.14,1.14,0,0,0,41.78,10.44ZM32.1,3.15l3.13,3.09H32.1Zm-.92-.64V6.7a.46.46,0,0,0,.46.45h4.24v3.1H18V2.51Zm2.75,27H18v-8.2l.16-1.5H36v9.7Z",
    transform: "translate(-10.99 -1.6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.691ced89.svg";
export { ForwardRef as ReactComponent };